import styled from "styled-components"

const Wrapper = styled.a`  
  background-size: cover;
  background-repeat: no-repeat;  
  display: block;
  height: 450px;  
  padding: 30px 10px;
  position: relative;
  width: 100%;

  @media only screen and (max-width: calc(${props => props.theme.mq.xsmall} - 1px)) {
    text-align: center;
    }

  @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
    align-items: flex-start;
    display: flex;
    flex-wrap: wrap;
    height: 220px;
    justify-content: space-between;
    padding: 20px 30px;
    }

  &:before {
    background-color: rgba(0, 0, 0, 0.3);
    content: "";
    display: block;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 5;
  }

  > * {
    position: relative;
    z-index: 10;
  }

  p {
    color: #fff;
    display: block;
    font-size: 30px;
    line-height: 1;
    margin: 0 auto;
    width: 100%;

    @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
        margin: 0;
    }
  }

  span {
    display: flex;

    @media only screen and (max-width: calc(${props => props.theme.mq.xsmall} - 1px)) {
        bottom: 30px;
        left: 50%;
        position: absolute;
        transform: translateX(-50%);
        z-index: 5;
    }

    @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
        justify-content: flex-end;
        margin-top: auto;
        order: 3;
        width: 100%;
    }
  }

  img {
    display: block;
    height: auto;
    width: 60px;

    @media only screen and (max-width: calc(${props => props.theme.mq.xsmall} - 1px)) {
        margin: 0 auto 25px;    
    }

    @media only screen and (min-width: ${props => props.theme.mq.xsmall}) {
        order: 2;
    }
  }

  button {
    align-items: center;
    background-color: ${props => props.theme.colors.primary};
    border-radius: 3px;
    color: #fff;
    cursor: default;
    display: flex;
    font-size: 11px;
    font-weight: 600;
    height: 30px;
    justify-content: center;
    letter-spacing: .5px;
    pointer-events: none;
    text-align: center;
    width: 100px;    
  }
`

export const sBanner = {
  Wrapper,
}
